import type ShopWindowConfig from "@/plugin/ShopWindowConfig";

export default class ShopWindowConfigList {
  declare _list: ShopWindowConfig[];
  declare _map: Record<string, ShopWindowConfig>;

  constructor() {
    this._list = [];
    this._map = {};
  }

  add(config: ShopWindowConfig) {
    this._list.push(config);
    this._map[config.name] = config;
  }

  atName(name: string | true): ShopWindowConfig | undefined {
    return this._map[String(name)];
  }

  atIndex(index: number): ShopWindowConfig {
    return this._list[index];
  }

  get asList() {
    return this._list;
  }

  get asMap() {
    return this._map;
  }

  get count() {
    return this._list.length;
  }
}
